import { render } from "./ModuleInscriptionForm.vue?vue&type=template&id=45190e95&scoped=true"
import script from "./ModuleInscriptionForm.vue?vue&type=script&lang=js"
export * from "./ModuleInscriptionForm.vue?vue&type=script&lang=js"

import "./ModuleInscriptionForm.vue?vue&type=style&index=0&id=45190e95&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45190e95"]])

export default __exports__